const divModalFilterExpiredServices = {
  cancel: 'CANCEL',
  ok: 'APPLY',
  mandatory: 'Show Mandatory Services',
  nonMandatory: 'Show Optional Services',
};

export default divModalFilterExpiredServices;
